// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__EhOu_","iconWithCounter":"styles_iconWithCounter__od0MB","counterForLabel":"styles_counterForLabel__Tuo9y","counterForIcon":"styles_counterForIcon___z0jV"};